import { Injectable } from '@angular/core';
import { AnalyticsService } from './analytics.service';
import { moduleKey } from 'app/core/constants/constants';

@Injectable({
  providedIn: 'root'
})
export class MarkupEventAnalyticsService {

  constructor(private analyticsService: AnalyticsService,) { }

  trackEventAnalytics(module): void{
    let eventName: string;
    const eventNameSuffix = '-partsandservices-markup';
    switch(module){
      case moduleKey.ESTIMATES:
        eventName = 'Quotes' + eventNameSuffix;
        break;
      case moduleKey.INVOICE:
        eventName = 'Invoice' + eventNameSuffix;
        break;
      case moduleKey.SERVICE_CONTRACTS:
        eventName = 'Contract' + eventNameSuffix;
        break;
      case moduleKey.JOB:
        eventName = 'Job' + eventNameSuffix;
        break;
      case moduleKey.PRODUCTS:
        eventName = 'partsandservices-markup';
    };
    if(eventName){
      this.analyticsService.trackEvent(eventName);
    }
  }
}
